import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConstants } from '../util/app.constants';
import { of } from 'rxjs';

// Based on: https://juristr.com/blog/2018/01/ng-app-runtime-config/

export function configurationServiceInitializerFactory(configurationService: ConfigService): Function {
  // lambda required here, otherwise won't work inside ConfigurationService::load
  return () => configurationService.load();
}

@Injectable()
export class ConfigService {
  private loaded = false;
  private config: any;

  constructor(private http: HttpClient) {}

  public getConfig(): any {
    return this.config;
  }

  public getValue(key: string, orDefault: any = null): any {
    if (!this.config || !(key in this.config)) {
      return orDefault;
    }
    return this.config[key];
  }

  // return value Promise of this method is used as an APP_INITIALIZER,
  // so the application's initialization will not complete until the Promise resolves.
  public load(): Promise<any> {
    if (this.loaded) {
      return of(this, this.config).toPromise();
    } else {
      return this.http
        .get(AppConstants.CONFIG_PATH)
        .toPromise()
        .catch(err => {
          console.error(`Error loading configuration: ${JSON.stringify(err)}`);
          return of({});
        })
        .then(config => {
          this.config = config;
          this.loaded = true;
        });
    }
  }
}
